"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ChevronRight } from "lucide-react";
export default function AboutRestaurant() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll();
  return <section data-section-id="256075" id="die-vision-hinter-chrotech" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        {}
        <div className="flex flex-col items-center mb-12 md:mb-16">
          <img src="/img/chrotech_logo_dark.png" alt="CHROTECH Logo" className="mb-6 !w-[160px] !h-[48px]" loading="lazy" decoding="async" src="https://good-piranha.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-May-11-2026-05_10_35-PM-1.png" src="https://good-piranha.10web.cloud/wp-content/uploads/2026/05/CHROTECH_logo_cropped_transparent-1.png" />
          <h1 className="font-default text-3xl md:text-5xl lg:text-7xl font-bold text-center tracking-tight" style={{
          color: "var(--foreground)"
        }}>
            Die Vision hinter <span className="text-primary">CHROTECH</span>
          </h1>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center">
          {}
          <div ref={contentRef} className={`transition-all duration-700 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-6">
              <p className="font-default text-muted-foreground text-base md:text-xl leading-relaxed">CHROTECH steht für technologische Exzellenz, moderne KI-Automatisierung und innovative digitale Lösungen für Unternehmen.</p>

              <p className="font-default text-muted-foreground text-base md:text-xl leading-relaxed">Unser Anspruch ist es, Unternehmen nicht nur technisch zu unterstützen, sondern langfristig als digitaler Partner zu begleiten.<div>Mit modernen Systemen, Automatisierung und kreativen Strategien schaffen wir effiziente, sichere und zukunftsorientierte Lösungen.</div></p>

              <div className="space-y-3 md:space-y-4">
                <div className="flex items-start gap-3">
                  <span className="text-lg mt-1 shrink-0 text-primary">
                    •
                  </span>
                  <p className="font-default text-foreground text-sm md:text-base font-medium">Moderne IT- &amp; KI-Lösungen für Unternehmen</p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-lg mt-1 shrink-0 text-primary">
                    •
                  </span>
                  <p className="font-default text-foreground text-sm md:text-base font-medium">Professionelle Webseiten &amp; digitales Marketing</p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-lg mt-1 shrink-0 text-primary">
                    •
                  </span>
                  <p className="font-default text-foreground text-sm md:text-base font-medium">Automatisierung, Sicherheit &amp; zuverlässiger Support</p>
                </div>
              </div>

              <Link to="/HomePage">
                <Button variant="outline" className="mt-6 text-primary border-primary hover:bg-primary/10 rounded-lg font-semibold tracking-wide">
                  Unsere Expertise entdecken
                  <ChevronRight className="w-4 h-4" />
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`transition-all duration-700 ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1669233/img/chrotech_founder_portrait.png" alt="CHROTECH Gründer Vision" className="w-full h-auto rounded-2xl shadow-2xl border border-white/10" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1669233/img/chrotech_founder_portrait.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1669233/img/chrotech_founder_portrait.png-wvc-sizes" loading="lazy" decoding="async" src="https://good-piranha.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-May-13-2026-04_13_21-PM-2.png" />
              <div className="absolute inset-0 rounded-2xl border-2 -z-10 translate-x-4 translate-y-4 opacity-50 blur-xl bg-primary/20" style={{
              borderColor: "var(--primary)"
            }} />
              {}
              <div className="absolute bottom-6 left-6 right-6 p-6 backdrop-blur-xl bg-card/60 rounded-xl border border-white/10 shadow-lg">
                <p className="font-default text-foreground italic text-sm md:text-base mb-2">
                  "Innovation ist kein Ziel, sondern ein kontinuierlicher Prozess der Exzellenz."
                </p>
                <p className="font-default text-primary font-bold text-xs uppercase tracking-widest">— CHROTECH</p>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 md:mt-24 pt-12 md:pt-16 border-t border-border">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <h3 className="font-default text-2xl md:text-4xl font-bold mb-2 text-primary">10+</h3>
              <p className="font-default text-muted-foreground text-sm md:text-base uppercase tracking-wider">
                Jahre Erfahrung
              </p>
            </div>
            <div className="text-center">
              <h3 className="font-default text-2xl md:text-4xl font-bold mb-2 text-primary">
                150+
              </h3>
              <p className="font-default text-muted-foreground text-sm md:text-base uppercase tracking-wider">
                Erfolgreiche Projekte
              </p>
            </div>
            <div className="text-center">
              <h3 className="font-default text-2xl md:text-4xl font-bold mb-2 text-primary">
                100%
              </h3>
              <p className="font-default text-muted-foreground text-sm md:text-base uppercase tracking-wider">
                Deutsche Qualität
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}